import { IVetExamState } from "interfaces/VetExamState";
import {
  IVetExamActions,
  SET_CURRENT_PAST_EXAM_ID,
  SET_IS_EDIT_PAST_EXAM_FORM_OPEN,
  SET_IS_EXAM_FORM_OPEN,
  SET_IS_USE_LAST_EXAM_ENTRY,
  SET_MODAL_STATE,
  SET_MODAL_TYPE
} from "store/actions/vetExam";

const initialState: IVetExamState = {
  isExamFormOpen: false,
  isEditPastExamFormOpen: false,
  modalState: false,
  modalType: null,
  isUseLastExamEntry: false,
  currentPastExamId: null
};

export default (
  state: IVetExamState = initialState,
  action: IVetExamActions
): IVetExamState => {
  switch (action.type) {
    case SET_IS_EXAM_FORM_OPEN:
      return {
        ...state,
        isExamFormOpen: action.isExamFormOpen
      };
    case SET_MODAL_STATE:
      return {
        ...state,
        modalState: action.modalState
      };
    case SET_MODAL_TYPE:
      return {
        ...state,
        modalType: action.modalType
      };
    case SET_IS_USE_LAST_EXAM_ENTRY:
      return {
        ...state,
        isUseLastExamEntry: action.isUseLastExamEntry
      };
    case SET_IS_EDIT_PAST_EXAM_FORM_OPEN:
      return {
        ...state,
        isEditPastExamFormOpen: action.isEditPastExamFormOpen
      };
    case SET_CURRENT_PAST_EXAM_ID:
      return {
        ...state,
        currentPastExamId: action.currentPastExamId
      };
    default:
      return state;
  }
};
